export { default } from './ErrorBoxMessage';
